import { blocks } from '@yola/ws-sdk';
import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants: { events },
} = segment;

export function trackRequestWidgetButtonClicked({ wsBlockElement }) {
  const targetBlockId = blocks.accessors.getBlockIdByElement(wsBlockElement);
  const targetBlockVariationId = blocks.accessors.getVariationIdByElement(wsBlockElement);

  trackEvent(events.WIDGET_SELECTOR_REQUEST_WIDGET_BUTTON_CLICKED, {
    targetBlockId,
    targetBlockVariationId,
  });
}

export function trackWidgetSearchClicked({ wsBlockElement }) {
  const targetBlockId = blocks.accessors.getBlockIdByElement(wsBlockElement);
  const targetBlockVariationId = blocks.accessors.getVariationIdByElement(wsBlockElement);

  trackEvent(events.WIDGET_SELECTOR_SEARCH_CLICKED, {
    targetBlockId,
    targetBlockVariationId,
  });
}

export function trackWidgetSearchPerformed({ wsBlockElement, searchTerm, searchResults }) {
  const targetBlockId = blocks.accessors.getBlockIdByElement(wsBlockElement);
  const targetBlockVariationId = blocks.accessors.getVariationIdByElement(wsBlockElement);

  trackEvent(events.WIDGET_SELECTOR_SEARCH_PERFORMED, {
    targetBlockId,
    targetBlockVariationId,
    searchTerm,
    searchResults,
  });
}
